import { Injectable } from '@angular/core';
import { InfoTerritorialService } from '../../services/info-territorial.service';

interface Pais {
    idPais: number;
    pais: string;
    nacionalidad: string;
    codPais: number;
}

interface Region {
    idRegion: number;
    region: string;
}

interface Comuna {
    idComuna: number;
    idProvincia: number;
    comuna: string;
}

@Injectable({
    providedIn: 'root',
})
export class RegionUtils {


    constructor(private infoTerritorialService: InfoTerritorialService) {
    }

    public getPaisesDropdown(): any[] {
        let listPaises = []
        this.infoTerritorialService.getPaises().then( paises => {            
            paises.forEach(( pais: Pais ) => {
                if(pais.idPais != 152)
                listPaises.push({label: pais.pais, value: pais.idPais});
            });
        });
        return listPaises;
    }

    public getRegionesDropdown(): any[] {
        let listRegiones = []
        this.infoTerritorialService.getRegiones().then( regiones => {
            regiones.forEach(( region: Region ) => {
                listRegiones.push({label: region.region, value: region.idRegion});
            });
        });
        return listRegiones;
    }

    async getAsyncRegionesDropdown(): Promise<Region[]> {
        let regiones = await this.infoTerritorialService.getRegiones()
        regiones.forEach(( region: Region, index: number ) => {
            regiones[index] = {label: region.region, value: region.idRegion};
        });
        return regiones;       
    }

    public getComunasRegionDropdown(idRegion: number): any[] {
        let listComunas = [];
        this.infoTerritorialService.getComunasRegion({idRegion: idRegion}).then( comunas => {
            comunas.forEach( (comuna: Comuna) => {
                listComunas.push({label: comuna.comuna, value: comuna.idComuna});
            });
        });
        return listComunas;
    }

    async getAsyncComunasDropdown(idRegion: number): Promise<Region[]> {
        let comunas = await this.infoTerritorialService.getComunasRegion({idRegion: idRegion})
        comunas.forEach(( comuna: Comuna, index: number ) => {
            comunas[index] = {label: comuna.comuna, value: comuna.idComuna};
        });
        return comunas;       
    }

}
